import { MatSpinner } from '@angular/material/progress-spinner';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output, signal, Signal, ViewChild } from '@angular/core';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import {MatDivider, MatListModule, MatListOption, MatSelectionList, MatSelectionListChange} from '@angular/material/list';
import { ListItem } from '../../model';
import {PageEvent, MatPaginatorModule, MatPaginator} from '@angular/material/paginator';
import { MatButton, MatAnchor, MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOption } from "@angular/material/select";
import { SlicePipe } from '@angular/common';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSort } from '@angular/material/sort';
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatTooltip } from "@angular/material/tooltip";

@Component({
  selector: 'app-list-component',
  imports: [
    MatListModule,
    MatFormFieldModule,
    MatIcon,
    MatInputModule,
    MatPaginatorModule,
    MatCardModule,
    MatButtonModule,
    MatListModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    MatListModule,
    MatDivider
],
  templateUrl: './list-component.html',
  styleUrl: './list-component.css',
})
export class ListComponent {

  @Input() data : ListItem[] = []

  @Input() multi : boolean = false

  @Input() page : number = 5

  @Output() Values = new EventEmitter<ListItem[]>();

  dataSource : MatTableDataSource<ListItem> = new MatTableDataSource<ListItem>([])

  selection = new SelectionModel<ListItem>(true, []);
  originData : ListItem[] = []

  listes : ListItem[] = []

  allCheck : boolean = false

  searchControl : FormControl = new FormControl('')
  $index: any;

  selectedIds = new Set<any>();

  ngOnInit(): void {
    console.log('data : ', this.data);
    
    this.dataSource.data = this.data.slice()
  }

  ngAfterViewInit() {

  }


  resetInput(event: Event){
    this.searchControl.setValue("")
    this.dataSource.filter = "";

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  setValue(item : ListItem){
    if(item.disabled)return;

    //multi select
    const index = this.listes.findIndex(elt => elt.id == item.id)
    if(index == -1)
      this.listes.push(item)

    if(index != -1)
      this.listes.splice(index, 1)

    this.Values.emit(this.listes.slice())
  }


isSelected(item: ListItem): boolean {
  if(item.id == 'dr' || item.id == 'rc') return true;
  return this.selectedIds.has(item.id);
}

onSelectionChange(event: MatSelectionListChange) {
  for (const option of event.options) {
    const item: ListItem = option.value;
    if (option.selected) {
      this.selectedIds.add(item.id);
    } else {
      this.selectedIds.delete(item.id);
    }
  }

  this.listes = this.dataSource.data.filter(i => this.selectedIds.has(i.id));
  this.allCheck = this.dataSource.data
    .filter(i => !i.disabled)
    .every(i => this.selectedIds.has(i.id));

  this.Values.emit(this.listes.slice());
}

setAllValues(checked: boolean) {
  this.selectedIds.clear();
  if (checked) {
    this.dataSource.data.forEach(i => {
      if (!i.disabled) this.selectedIds.add(i.id);
    });
  }
  this.allCheck = checked;
  this.listes = this.dataSource.data.filter(i => this.selectedIds.has(i.id));
  this.Values.emit(this.listes.slice());
}

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

}
